module.exports = __webpack_public_path__ + "static/media/1947 Loxwood, UK.95004884.jpg";